import {CONTRACTORS_CREATE, CONTRACTORS_UPDATE, CONTRACTORS_DELETE} from './available'
import _ from 'lodash'

export default {
  [CONTRACTORS_CREATE](state, contractor) {
    state.availableContractors.unshift(contractor)
  },
  [CONTRACTORS_UPDATE](state, contractor) {
    let contractorIndex = _.findIndex(state.availableContractors, function(item) {
      return item.id === contractor.id
    })

    if (contractorIndex < 0) {
      return
    }

    state.availableContractors.splice(contractorIndex, 1, contractor)
  },
  [CONTRACTORS_DELETE](state, contractor) {
    let contractorIndex = _.findIndex(state.availableContractors, function(item) {
      return item.id === contractor.id
    })

    if (contractorIndex < 0) {
      return
    }

    state.availableContractors.splice(contractorIndex, 1)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/contractors.js